import React from "react";
import createSvgIcon from "@material-ui/core/utils/createSvgIcon";

/**
 * author: Colton Wiscombe
 * id 6DDFDD69-EBA5-4BFB-A44F-6B84A7B3A4BC
 * name book-alert-outline
 * version: 5.8.55
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/book-alert-outline.svg
 * tags
 * - Alert / Error 
 */
export const BookAlertOutlineIcon = createSvgIcon(<><path d="M16 2H4C2.9 2 2 2.9 2 4V20C2 21.11 2.9 22 4 22H16C17.11 22 18 21.11 18 20V4C18 2.9 17.11 2 16 2M16 20H4V4H6V12L8.5 9.75L11 12V4H16V20M20 15H22V17H20V15M22 7V13H20V7H22Z" /></>, 'BookAlertOutlineIcon');
export default BookAlertOutlineIcon